import ProductCardY from './ProductCardY';

export default ProductCardY;
